export default __webpack_public_path__ + "static/media/card-4.5668270d.webp";